import loadable from '@loadable/component';
import Loading from '../components/Loader';

const LoginGate = loadable(
  () => import(/* webpackChunkName: "login" */ '../containers/LoginGate'),
  { fallback: Loading }
);

export default LoginGate;
